module.exports = __webpack_public_path__ + "b6c575744f639b0533dca8dced1b6d21.MP3";